import { useState } from 'react';

// The user's profile picture, or their initial when there isn't one (or it
// fails to load).
const UserAvatar = ({ user, size = 44 }) => {
    const [ broken, setBroken ] = useState(false);
    const style = { width: size, height: size };
    if (user.icon && !broken) {
        return <img src={user.icon} alt='' className='user-avatar' style={style} onError={() => setBroken(true)} />;
    }
    return (
        <span className='user-avatar initial' style={{ ...style, fontSize: size * 0.45 }} aria-hidden='true'>
            {(user.name || user.email || '?').charAt(0).toUpperCase()}
        </span>
    );
}

export default UserAvatar
